import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { ActivityRoutes } from './activity/activity-routes';
import { useBarcodeScannerRoutes } from './features/barcode-scanner/barcode-scanner-routes';
import { useReceiveDirtyLaundryRoutes } from './features/receive-dirty-laundry/receive-dirty-laundry-routes';
import { useSendCleanLaundryRoutes } from './features/send-clean-laundry/send-clean-laundry-routes';
import { ItemsRoutes } from './items/items-routes';

const Home = lazy(() => import('./home/home.component'));
const LaundryActivityDetail = lazy(() => import('./activity/laundry-activity-detail/laundry-activity-detail.component'));

export function LaundryRoutes() {
    const barcodeScannerRoutes = useBarcodeScannerRoutes();
    const sendCleanLaundryRoutes = useSendCleanLaundryRoutes();
    const receiveDirtyLaundryRoutes = useReceiveDirtyLaundryRoutes();
    const itemRoutes = ItemsRoutes();
    const activityRoutes = ActivityRoutes();
    return (
        <Route path='laundry'>
            <Route
                index
                element={<Navigate to='home' />}
            />
            <Route path='home'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <Home />
                        </AsyncComponent>
                    }
                />
            </Route>
            <Route path=':transactionId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <LaundryActivityDetail />
                        </AsyncComponent>
                    }
                />
            </Route>

            {itemRoutes}
            {activityRoutes}
            {sendCleanLaundryRoutes}
            {receiveDirtyLaundryRoutes}
            {barcodeScannerRoutes}
        </Route>
    );
}
